import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab } from 'react-bootstrap';
import { clone } from 'ramda';
import { Helmet } from 'react-helmet';
import queryString from 'query-string';
import Button from '@components/@core/AnimatedButton';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Pagination from '@components/@core/Pagination';
import { AppActions, CommunityActions } from '~/actions';
import CommunityHeader from '~/views/Community/Community/Header';
import TopicList from './TopicList';
import SearchResult from './SearchResult';
import withNavigate from '~/hocs/withNavigate';

class Forums extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: queryString.parse(props.location?.search || '')?.active || 'recent',
            categoryId: null,
            page: props.location?.state?.page ?? 1,
            perPage: props.location?.state?.perPage ?? 10,
            search: '',
            adsData: [],
        };
    }

    componentDidMount() {
        const { page, perPage } = this.state;
        this.props.getTopics({ order: 'recent', page, per_page: perPage });
        this.handleFetchAds();
    }

    componentDidUpdate(prevProps, prevState) {
        const { search, categoryId } = this.state;
        if (prevState.search !== search || prevState.categoryId !== categoryId) {
            const payload = { category_id: categoryId, search };
            this.props.searchTopics(payload);
        }
    }

    handleFetchAds = () => {
        const adsData = [];
        window.broadstreetNative = (el, ads) => {
            adsData.push(ads);
            this.setState({ adsData });
        };
    };

    handleGetTopics = () => {
        const { page, perPage } = this.state;
        const payload = { order: 'recent', page, per_page: perPage };
        this.props.getTopics(payload);
    };

    handleAddForum = () => {
        const { token } = this.props;
        if (token) {
            const after = { type: 'GETBLOGCATEGORIES_REQUEST' };
            this.props.toggleModal({
                type: 'Add Forum',
                data: { before: { after } },
                callBack: this.handleGetTopics,
            });
        } else {
            const route = '/forums';
            this.props.toggleModal({
                type: 'Authentication',
                data: {
                    before: {
                        route,
                        after: {
                            type: 'GETTOPICS_REQUEST',
                            payload: { order: 'recent', page: 1, per_page: 10 },
                        },
                    },
                },
            });
        }
    };

    handlePagination = (e) => {
        this.setState({ page: e }, () => this.handleGetTopics());
    };

    handleTab = (e) => {
        this.props.navigate({ search: `?active=${e}` });
        this.setState({ activeTab: e });
    };

    handleMenu = (event, item, page, perPage) => {
        if (event === 'edit') {
            const after = { type: 'GETBLOGCATEGORIES_REQUEST' };
            this.props.toggleModal({
                type: 'Add Forum',
                data: { before: { topic: item, event, page, perPage, after } },
                callBack: this.handleGetTopics,
            });
        } else if (event === 'delete') {
            const payload = { topic: { id: item.id } };
            this.props.toggleModal({
                type: 'Confirm',
                data: { before: { title: 'Delete', body: 'Are you sure you want to delete this item?' } },
                callBack: {
                    onYes: () => this.props.deleteTopics(payload, this.handleGetTopics),
                },
            });
        }
    };

    handleSearch = () => {
        this.props.toggleModal({
            type: 'Search Topic',
            data: { before: { departmentIds: this.state.categoryId } },
            callBack: (search, categoryId) => this.setState({ search, categoryId: categoryId?.length === 0 ? null : categoryId }),
        });
    };

    handleSearchTopic = (e) => {
        const { search, categoryId } = this.state;
        const { per_page } = this.props.individualTopic.topics;
        const payload = { category_id: categoryId, search, per_page, page: e };
        this.props.searchTopics(payload);
    };

    handleCancelSearch = (type) => () => {
        if (type === 'search') {
            this.setState({ search: '' });
        } else {
            let _categoryId = this.state.categoryId.filter((item) => item !== type);
            this.setState({ categoryId: _categoryId.length < 1 ? null : _categoryId });
        }
    };

    render() {
        const { individualTopic, departments, topics, userRole, communityId, userId } = this.props;
        const { adsData, activeTab, categoryId, page, perPage, search } = this.state;

        return (
            <ErrorBoundary className="community-forum">
                <Helmet>
                    <title>Dealership best practice forum, automotive social network | DrivingSales</title>
                    <meta name="description" content="Dealership best practice forum, automotive social network | DrivingSales" />
                </Helmet>
                <broadstreet-zone zone-id="99535"></broadstreet-zone>
                <CommunityHeader activeRoute="Forums" searchTitle="Topic" addTitle="Topic" onModal={this.handleAddForum} onSearch={this.handleSearch} />
                <div className="card">
                    <p className="dsl-b22 bold">{!categoryId ? 'Forums' : 'Search Results'}</p>
                    {!categoryId && search === '' ? (
                        <Tabs id="community-forums" defaultActiveKey="recent" activeKey={activeTab} onSelect={this.handleTab}>
                            <Tab key="recent" eventKey="recent" title="Recent">
                                <TopicList
                                    adsData={adsData}
                                    data={topics?.topics?.data}
                                    displayMenu
                                    userRole={userRole}
                                    communityId={communityId}
                                    page={page}
                                    perPage={perPage}
                                    onMenu={this.handleMenu}
                                    userId={userId}
                                />
                                <div className="d-h-between flex-wrap mt-3">
                                    <Pagination className="p-0 mb-2" current={page} per={perPage} pers={[]} total={topics?.topics?.last_page} onChange={this.handlePagination} />
                                    <Button name="ADD TOPIC" onClick={this.handleAddForum} />
                                </div>
                            </Tab>
                        </Tabs>
                    ) : (
                        <SearchResult
                            topics={individualTopic?.topics}
                            search={search}
                            departments={departments}
                            categoryId={categoryId}
                            onCancel={this.handleCancelSearch}
                            onSearch={this.handleSearchTopic}
                        />
                    )}
                </div>
            </ErrorBoundary>
        );
    }
}

const mapStateToProps = (state) => ({
    token: state.app.token,
    communityId: state.app.user?.community_user?.id,
    userRole: state.app.app_role_id,
    departments: state.company.blogCategories,
    individualTopic: state.community.individualTopic,
    topics: state.community.topics['all'],
    userId: state.app.user.community_user_id,
});

const mapDispatchToProps = (dispatch) => ({
    searchTopics: (e) => dispatch(CommunityActions.getforumindividualtopicRequest(e)),
    getTopics: (e) => dispatch(CommunityActions.gettopicsRequest(e)),
    deleteTopics: (payload, callback) => dispatch(CommunityActions.deleteforumtopicRequest(payload, callback)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const ForumsWithNavigate = withNavigate(Forums);

export default connect(mapStateToProps, mapDispatchToProps)(ForumsWithNavigate);
